// src/hooks/useThemeConfig.ts
import { useMemo } from 'react';
import themeConfig from '@src/configs/themeConfig';

export const useTheme = () => {
  return useMemo(() => {
    return themeConfig;
  }, []);
};
